// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BHKJS .ant-pagination-item-active:hover a {
  color: #fff;
}
.BHKJS .ant-pagination-item-active a {
  color: #fff;
}
.BHKJS .ant-pagination-item {
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.04);
  border-radius: 12px;
}
.BHKJS .ant-pagination-item:not(.ant-pagination-item-active) a {
  font-size: 14px;
  color: #333;
}
.BHKJS .ant-pagination-jump-prev,
.BHKJS .ant-pagination-jump-next {
  border: 1px solid #d9d9d9;
}
.BHKJS .ant-pagination-jump-prev .ant-pagination-item-link .ant-pagination-item-container .ant-pagination-item-ellipsis,
.BHKJS .ant-pagination-jump-next .ant-pagination-item-link .ant-pagination-item-container .ant-pagination-item-ellipsis {
  letter-spacing: 0;
  font-size: 8px;
  color: #333;
}
.BHKJS .ant-pagination-prev,
.BHKJS .ant-pagination-next {
  color: #b8b8b8;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"BPagination": `BHKJS`,
	"bPagination": `BHKJS`
};
export default ___CSS_LOADER_EXPORT___;
